export const topics = [
  {
    slug: "variety",
    name: "综艺现场",
    desc: "首播舞台、嘉宾名单、录制路透，综艺相关的讨论都归在这里，更新最密集的栏目之一。",
    count: 168,
    image: "https://readdy.ai/api/search-image?query=warm%20abstract%20stage%20spotlight%20with%20amber%20and%20red%20haze%20minimal%20artistic%20texture%20no%20people%20editorial%20background%20high%20detail&width=800&height=600&seq=hlwb-topic-variety&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=warm%20abstract%20concert%20stage%20lights%20amber%20and%20crimson%20gradient%20soft%20grain%20artistic%20texture%20no%20people&width=1200&height=500&seq=hlwb-cover-variety&orientation=landscape",
  },
  {
    slug: "screen",
    name: "影视动态",
    desc: "剧集杀青、电影预告、定档资讯与幕后花絮，追剧党的每日必看栏目。",
    count: 214,
    image: "https://readdy.ai/api/search-image?query=warm%20abstract%20cinema%20light%20beam%20through%20haze%20amber%20tones%20minimal%20artistic%20texture%20no%20people%20editorial%20background%20high%20detail&width=800&height=600&seq=hlwb-topic-screen&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=warm%20abstract%20film%20projector%20beam%20amber%20and%20cream%20gradient%20soft%20grain%20artistic%20texture%20no%20people&width=1200&height=500&seq=hlwb-cover-screen&orientation=landscape",
  },
  {
    slug: "music",
    name: "音乐现场",
    desc: "音乐节阵容、巡演加场、票价与抢票信息，现场氛围提前感受。",
    count: 132,
    image: "https://readdy.ai/api/search-image?query=warm%20abstract%20soundwave%20texture%20amber%20and%20teal%20gradient%20minimal%20artistic%20no%20people%20editorial%20background%20high%20detail&width=800&height=600&seq=hlwb-topic-music&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=warm%20abstract%20audio%20waveform%20amber%20teal%20cream%20gradient%20soft%20grain%20artistic%20texture%20no%20people&width=1200&height=500&seq=hlwb-cover-music&orientation=landscape",
  },
  {
    slug: "brand",
    name: "品牌代言",
    desc: "代言官宣、大片释出、联名限定，商业动态里的审美与话题。",
    count: 96,
    image: "https://readdy.ai/api/search-image?query=warm%20abstract%20silk%20fabric%20folds%20in%20amber%20and%20cream%20soft%20studio%20light%20minimal%20no%20people%20editorial%20background%20high%20detail&width=800&height=600&seq=hlwb-topic-brand&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=warm%20abstract%20draped%20fabric%20amber%20cream%20gradient%20soft%20grain%20artistic%20texture%20no%20people&width=1200&height=500&seq=hlwb-cover-brand&orientation=landscape",
  },
  {
    slug: "buzz",
    name: "网络热议",
    desc: "冲上热搜的话题、被反复讨论的细节，网友都在说什么。",
    count: 187,
    image: "https://readdy.ai/api/search-image?query=warm%20abstract%20bokeh%20light%20dots%20amber%20and%20red%20minimal%20artistic%20texture%20no%20people%20editorial%20background%20high%20detail&width=800&height=600&seq=hlwb-topic-buzz&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=warm%20abstract%20bokeh%20city%20lights%20amber%20red%20cream%20gradient%20soft%20grain%20no%20people&width=1200&height=500&seq=hlwb-cover-buzz&orientation=landscape",
  },
  {
    slug: "overseas",
    name: "海外娱乐",
    desc: "海外剧集、综艺与颁奖季动态，字幕组与追更党的信息站。",
    count: 88,
    image: "https://readdy.ai/api/search-image?query=warm%20abstract%20night%20city%20skyline%20silhouette%20amber%20and%20teal%20haze%20minimal%20artistic%20no%20people%20editorial%20background%20high%20detail&width=800&height=600&seq=hlwb-topic-overseas&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=warm%20abstract%20night%20cityscape%20amber%20teal%20cream%20gradient%20soft%20grain%20artistic%20texture%20no%20people&width=1200&height=500&seq=hlwb-cover-overseas&orientation=landscape",
  },
];